import { useState } from 'react';
import apiService from '../../axios/apiService';
import { message } from 'antd';

export const useCreateCustomDurationInvoices = () => {
  const [loading, setLoading] = useState(false);
  const createCustomDurationInvoices = async (data) => {
    // Create monthly invoices
    setLoading(true);
    try {
      await apiService.createCustomDurationInvoices(data);
      message.success('Monthly invoices created successfully');
    } catch (error) {
      console.log('Error: ', error);
      throw error;
    } finally {
      setLoading(false);
    }
  };

  return {
    loading,
    createCustomDurationInvoices,
  };
};
